import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaSearch, FaSortUp, FaSortDown, FaPen, FaPlus, FaFilter, FaTrash, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { API_URL_All } from '../api';
import axiosInstance from '../axiosInstance';
import * as general from '../libs/general';
import AdminLayout from '../components/AdLayout';
import Paging from '../components/Paging';
import { customerDetailPath } from '../routes/customerRoutes';


const ListCustomers = () => {
  const [pageData, setPageData] = useState({ content: [] });
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {

    searchUsers();
  }, []);

  const searchUsers = async (filter) => {
    setMessage('');
    var params = general.getSession('search_params');
    if (filter) Object.assign(params, filter);
    general.setSession('search_params', params);
    setSearchQuery(params.search);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};
    try {
      response = await axiosInstance.get('/api/users', { params: filteredParams });
      setPageData(response.data);
    } catch (error) {
      setPageData({ content: [] });
      setMessage(error.message);
      console.error(error);
    }
  };

  const handlePageChange = (page) => {
    var filter = {
      page: page - 1
    };
    searchUsers(filter);
  };

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    var filter = {
      size: newItemsPerPage
    };
    searchUsers(filter);
  };
  const handleSearchChange = async (e) => {
    var filter = {
      page: 0,
      search: e.target.value
    };
    setSearchQuery(e.target.value);
    searchUsers(filter);
  };

  return (
    <div>
      <AdminLayout>
        <div className="top_nav">
          <div className="nav_menu">
            <div className="nav toggle">
              <a id="menu_toggle"><i className="fa fa-arrow-right"></i><i className="fa fa-arrow-left"></i></a>
            </div>
            <div className="main-header">
              <div className="row">
                <div className="col-12 col-md-3 fw-bold text-uppercase d-flex align-items-center justify-content-star">
                  Quản lý khách hàng
                </div>
                <div className="col-12 col-md-9">
                  <div className="input-group w-50">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Tìm kiếm..."
                      value={searchQuery}
                      onChange={(e) => handleSearchChange(e)}
                    />
                    <button className="btn btn-light btn-sm" type="button" title="Tìm kiếm..." onClick={(event) => searchUsers({page:0})}>
                      <FaSearch />
                    </button>
                  </div>
                </div>
              </div>
              <div className="text-center d-none">DANH SÁCH KHÁCH HÀNG</div>
            </div>
          </div>
        </div>
        <div className="right_col" role="main">
          <div className="row">
            <div className="col-md-12 col-sm-12 ">
              <div className="x_panel">
                <div className="x_title" >
                  <h2 className="fw-bold">{title}Khách hàng</h2>
                  <ul className="nav navbar-right panel_toolbox">
                  </ul>
                  <div className="clearfix"></div>
                </div>
                <div className="x_content">
                  <div className="table-s">
                    <table>
                      <tbody>
                        <tr>
                          <th width="50px">STT</th>
                          <th width="100px">Mã KH</th>
                          <th>Tên</th>
                          <th>Email </th>
                        </tr>
                        {pageData.content.map((item, index) => (
                          <tr key={item.id}>
                            <td>{(pageData.number * pageData.size) + index + 1}</td>
                            <td className="cell-normal">
                              <span>{item.customerCode}</span>
                            </td>
                            <td className="cell-normal">
                              <Link to={customerDetailPath(item.id)}>{item.name}</Link>
                            </td>
                            <td className="cell-normal">
                              <span>{item.email}</span>
                            </td>
                          </tr>
                        ))}
                        {message === '' && pageData.content.length === 0 && (
                          <tr>
                            <td colSpan="4" className="text-center">Không tìm thấy dữ liệu</td>
                          </tr>
                        )}
                        {message !== '' && (
                          <tr>
                            <td colSpan="4" className="text-center">{message}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="my-2 d-flex justify-content-end align-items-center">
                    <Paging
                      pageData={pageData}
                      onPageChange={handlePageChange}
                      onItemsPerPageChange={handleChangeItemsPerPage}
                    />
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="d-none"> </footer>
      </AdminLayout>
    </div>
  );
};

export default ListCustomers;